import { TransactionListItem } from "@common/schemas/transaction.schema";
import { toDisplayDateOnly } from "@helpers/date";
import { useIsDateLocked } from "./useIsDateLocked";

export const useIsTransactionDateLocked = (
    transaction: Pick<TransactionListItem, "entity" | "dateOnly" | "date">,
) =>
    useIsDateLocked(
        transaction.entity.id,
        toDisplayDateOnly(transaction.dateOnly ?? transaction.date),
    );
